import { render, staticRenderFns } from "./oa-review.vue?vue&type=template&id=1be51e5b&scoped=true"
import script from "./oa-review.vue?vue&type=script&lang=js"
export * from "./oa-review.vue?vue&type=script&lang=js"
import style0 from "./oa-review.vue?vue&type=style&index=0&id=1be51e5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be51e5b",
  null
  
)

export default component.exports